import { render, staticRenderFns } from "./WA_Connect.vue?vue&type=template&id=12c246c8&scoped=true&"
import script from "./WA_Connect.vue?vue&type=script&lang=js&"
export * from "./WA_Connect.vue?vue&type=script&lang=js&"
import style0 from "./WA_Connect.vue?vue&type=style&index=0&id=12c246c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c246c8",
  null
  
)

export default component.exports